import { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';

const useAuthUser = (token) => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [hasSelectedStarter, setHasSelectedStarter] = useState(false);

    const fetchUserData = async (currentToken) => {
        if (!currentToken) {
            setIsLoading(false);
            return null;
        }

        try {
            const response = await axios.get('https://api.poketask.fr/api/me', {
                headers: { Authorization: `Bearer ${currentToken}` }
            });
            
            setUser(response.data);
            setHasSelectedStarter(response.data.hasSelectedStarter);
            setError(null);
            return response.data;
        } catch (err) {
            console.error('Erreur lors du chargement des données utilisateur:', err);
            setError(err);
            setUser(null);
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    // Effet pour charger les données utilisateur au démarrage et quand le token change
    useEffect(() => {
        if (token) {
            fetchUserData(token);
        } else {
            setUser(null);
            setIsLoading(false);
        }
    }, [token]);

    const updateUserFromToken = async (newToken) => {
        if (!newToken) {
            setUser(null);
            return;
        }
        
        try {
            const decoded = jwtDecode(newToken);
            const basicUser = {
                id: decoded.id,
                username: decoded.username,
                roles: decoded.roles,
            };
            setUser(basicUser);
            return basicUser;
        } catch (error) {
            console.error('Erreur lors du décodage du token:', error);
            setUser(null);
            setError(error);
        }
    };

    return {
        user,
        isLoading,
        error,
        hasSelectedStarter,
        updateUserFromToken,
        fetchUserData,
        setHasSelectedStarter
    };
};

export default useAuthUser;